import { SettingLandingBannersHomeInformationContainer } from "../";

export const SettingLandingBannersHomeMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingBannersHomeInformationContainer />
    </div>
  );
};
